import Modal from "Common/Components/Modal";
import React from "react";
import usePrices from "./hooks/usePrices";
import Dropzone from "react-dropzone";
import { UploadCloud } from "lucide-react";
import { Link } from "react-router-dom";

const acceptConfig = {
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
    ".xltx",
  ],
  "application/vnd.ms-excel-template": [".xlt"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
  "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12": [".xlsb"],
  "text/csv": [".csv"],
  "text/tab-separated-values": [".tab"],
};

const AddPricesModel = ({
  show,
  setShow,
}: {
  show: boolean;
  setShow: (val: boolean) => void;
}) => {
  const {
    toggle,
    selectfiles,
    handleAcceptfiles,
    setSelectfiles,
    handleAddDiamondPrices,
  } = usePrices({
    show,
    setShow,
  });
  return (
    <Modal
      show={show}
      onHide={toggle}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-5 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">Add Diamond Prices</Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <div className="mb-3">
          <label className="inline-block mb-2 text-base font-medium">
            {selectfiles ? "Uploaded File" : "Upload File"}
          </label>

          {selectfiles ? (
            <div className="flex justify-center" id="dropzone-preview2">
              {selectfiles && (
                <div className="mt-5" id="dropzone-preview-list2">
                  <div className="border rounded border-slate-200 dark:border-zink-500">
                    <div className="p-2 text-center">
                      <div className="pt-3">
                        <h5 className="mb-1 text-15" data-dz-name>
                          {selectfiles.path}
                        </h5>
                        <p
                          className="mb-0 text-slate-500 dark:text-zink-200"
                          data-dz-size
                        >
                          {selectfiles.formattedSize}
                        </p>
                        <strong
                          className="error text-danger"
                          data-dz-errormessage
                        ></strong>
                      </div>
                      <div className="mt-2">
                        <button
                          data-dz-remove
                          className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                          onClick={() => {
                            setSelectfiles("");
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <Dropzone
              onDrop={(acceptfiles: any) => {
                handleAcceptfiles(acceptfiles);
              }}
              accept={acceptConfig}
              maxFiles={1}
            >
              {({ getRootProps, getInputProps }: any) => (
                <div className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer dropzone border-slate-200 dropzone2 dark:bg-zink-600 dark:border-zink-500">
                  <div
                    className="w-full py-5 text-lg text-center dz-message needsclick"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div className="mb-3">
                      <UploadCloud className="block size-12 mx-auto text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500" />
                    </div>
                    <h5 className="mb-0 font-normal text-slate-500 dark:text-zink-200 text-15">
                      Drag and drop your file or <Link to="#!">browse</Link>{" "}
                      your file
                    </h5>
                  </div>
                </div>
              )}
            </Dropzone>
          )}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="reset"
            data-modal-close="addSellerModal"
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={toggle}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!selectfiles}
            onClick={handleAddDiamondPrices}
          >
            Upload
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddPricesModel;
